import 'arrive';
import $ from 'jquery';

document.arrive('.modal-block-hero-background', {existing: true}, function(){

    var $modal = $(this);
    // var auto_fullscreen = $modal.data('autofullscreen');

    $modal.on('shown.bs.modal', function (e) {
        $modal.find('video').get(0).play();

        // if(auto_fullscreen){
        //     if ($modal.find('video').get(0).requestFullscreen) {
        //         $modal.find('video').get(0).requestFullscreen();
        //     } else if ($modal.find('video').get(0).mozRequestFullScreen) {
        //         $modal.find('video').get(0).mozRequestFullScreen();
        //     } else if ($modal.find('video').get(0).webkitRequestFullscreen) {
        //         $modal.find('video').get(0).webkitRequestFullscreen();
        //     } else if ($modal.find('video').get(0).msRequestFullscreen) { 
        //         $modal.find('video').get(0).msRequestFullscreen();
        //     }
        // }

    })

    $modal.on('hide.bs.modal', function (e) {
        $modal.find('video').get(0).pause();
    })

});
document.arrive('.evenly-spaced', {existing: true}, function() {
    const nextSection = this.nextElementSibling;
    setTimeout(function () {
        const firstScrollElement = nextSection.querySelector('.aos-init');
        $(firstScrollElement).addClass('aos-animate')
    },
        200)
});